export default __webpack_public_path__ + "4a964ca644d822f7b31a81a3d29764e2.svg";